import { useSettings } from '@/data/Settings';
import { DPP_JOURNEY_QUERY_KEY } from '@/data/dpp/constants';
import { isValidDppJourneyId, readDppJourneyId, storeDppJourneyId } from '@/data/dpp/journey';
import {
	beaconFlushDppEvents,
	setDppTrackerStoreId,
	startDppTracker,
	stopDppTracker,
	trackDppEvent,
} from '@/data/dpp/tracker';
import { useEffect } from 'react';

export const useDppEvents = () => {
	const { settings } = useSettings();
	const storeId = settings?.storeId;

	useEffect(() => {
		setDppTrackerStoreId(storeId);
	}, [storeId]);

	useEffect(() => {
		const journeyId = new URL(globalThis.location.href).searchParams.get(DPP_JOURNEY_QUERY_KEY);
		if (!isValidDppJourneyId(journeyId)) return;
		if (readDppJourneyId() === journeyId) return;
		if (storeDppJourneyId(journeyId)) {
			trackDppEvent({ type: 'landing_view', source: 'landing' });
		}
	}, []);

	useEffect(() => {
		startDppTracker();

		const onPageHide = () => beaconFlushDppEvents();
		const onVisibilityChange = () => {
			if (document.visibilityState === 'hidden') beaconFlushDppEvents();
		};

		window.addEventListener('pagehide', onPageHide);
		document.addEventListener('visibilitychange', onVisibilityChange);

		return () => {
			window.removeEventListener('pagehide', onPageHide);
			document.removeEventListener('visibilitychange', onVisibilityChange);
			beaconFlushDppEvents();
			stopDppTracker();
		};
	}, []);
};
